import React from 'react'

interface IconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

const PlusCircleIcon: React.FC<IconProps> = ({ size = 24, className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 1536 1536"
      fill="currentColor"
      className={className}
      style={{ display: 'block' }}
      {...props}
    >
      <path d="M1216 832V704q0-26-19-45t-45-19H896V384q0-26-19-45t-45-19H704q-26 0-45 19t-19 45v256H384q-26 0-45 19t-19 45v128q0 26 19 45t45 19h256v256q0 26 19 45t45 19h128q26 0 45-19t19-45V896h256q26 0 45-19t19-45m320-64q0 209-103 385.5T1153.5 1433T768 1536t-385.5-103T103 1153.5T0 768t103-385.5T382.5 103T768 0t385.5 103T1433 382.5T1536 768" />
    </svg>
  )
}

export default PlusCircleIcon
